import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { gtm } from 'apps/gtm';
import { wa, pageEventTypes } from 'apps/analytics';

import { requestLogin } from 'utils/loginAndRegistration/login';

export default class FavouritesButton extends PureComponent {
  static propTypes = {
    addToFavourites: PropTypes.func.isRequired,
    inFavourites: PropTypes.bool.isRequired,
    isLoggedIn: PropTypes.bool.isRequired,
    onFavouritesSuccess: PropTypes.func,
    product: PropTypes.shape({
      sku: PropTypes.string.isRequired,
    }).isRequired,
    removeFromFavourites: PropTypes.func.isRequired,
    router: PropTypes.object.isRequired,
  };

  handleLoggedOut = () => {
    const { router } = this.props;

    requestLogin(router);
  }

  addToFavourites = () => {
    if (!this.props.isLoggedIn) {
      this.handleLoggedOut();
    }

    return this.props.addToFavourites(this.props.product.sku).then(() => {
      if (typeof this.props.onFavouritesSuccess === 'function') {
        gtm.trigger('gtm:uaEvent', {
          category: 'Favourites',
          action: 'Added to favourites',
          label: 'From Front of Pack',
        });
        wa.triggerPageEvent(pageEventTypes.QM_ADD_TO_FAVOURITES, {
          SOURCE: 'Front of Pack',
          SKU: this.props.product.sku,
        });
        this.props.onFavouritesSuccess();
      }
    });
  };

  removeFromFavourites = () => {
    if (!this.props.isLoggedIn) {
      this.handleLoggedOut();
    }

    return this.props.removeFromFavourites(this.props.product.sku).then(() => {
      if (typeof this.props.onFavouritesSuccess === 'function') {
        gtm.trigger('gtm:uaEvent', {
          category: 'Favourites',
          action: 'Removed from favourites',
          label: 'From Front of Pack',
        });
        wa.triggerPageEvent(pageEventTypes.QM_REMOVE_FROM_FAVOURITES, {
          SOURCE: 'Front of Pack',
          SKU: this.props.product.sku,
        });
        this.props.onFavouritesSuccess();
      }
    });
  };

  render() {
    const { inFavourites } = this.props;
    return (
      inFavourites ? (
        <button className="fop-quickMenu__options--tileAction" type="button" onClick={this.removeFromFavourites}>
          <span className="fop-quickMenu__options--tileFavourites fop-quickMenu__options--tileRemoveFromFavourites" />
          <span className="fop-quickMenu__options--tileLabel"> Remove from favourites</span>
        </button>
      ) : (
        <button className="fop-quickMenu__options--tileAction" type="button" onClick={this.addToFavourites}>
          <span className="fop-quickMenu__options--tileFavourites fop-quickMenu__options--tileAddToFavourites" />
          <span className="fop-quickMenu__options--tileLabel"> Add to favourites</span>
        </button>
      )
    );
  }
}
